// Class: haxe.IMap

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../hxClasses_stub").default;

// Constructor

var IMap = function() {}

// Meta

IMap.__name__ = ["haxe","IMap"];
IMap.__isInterface__ = true;
IMap.prototype = {
	
};
IMap.prototype.__class__ = IMap.prototype.constructor = $hxClasses["haxe.IMap"] = IMap;

// Init



// Statics




// Export

exports.default = IMap;